$(document).ready(function(){
        if($('.calming-formula-slider').length){
            $('.calming-formula-slider').owlCarousel({
            center: false,
            loop: false,
            dots: false,
            items: 2, 
            margin: 15,
            autoplay: false,
            nav: true,
            navText: [
                '<span class="owl-prev-arrow">‹</span>',
                '<span class="owl-next-arrow">›</span>'
                ],
            responsive: {
                991: {
                    items: 4,
                    margin: 26
                },
                767: {
                    items: 3,
                    margin: 15
                },
                512: {
                    items: 2,
                    margin: 14
                },
                0: {
                    items: 1,
                    margin: 12,
                    stagePadding: 30,
                    center: false
                }
            }
        });
        }

        $('.tab-buttons li').click(function(){
            var tab_id = $(this).attr('data-tab');
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            $(this).closest('.custom-tabs').find('.tab-pane').removeClass('active');
            $('#'+tab_id).addClass('active');
        });

        $(document).on('click', '.accordion-header', function(){
            var parent = $(this).closest('.accordion-item');
            if(parent.hasClass('active')){
                parent.removeClass('active');
                parent.find('.accordion-content').slideUp(200);
            }else{
                $('.accordion-item').removeClass('active');
                $('.accordion-content').slideUp(200);
                parent.addClass('active');
                parent.find('.accordion-content').slideDown(200);
            }
        });

        const $slides = $(".marquee__list");
        const cloneCount = 3;
        if($slides){
            for (let i = 0; i < cloneCount; i++) {
                $slides.children().clone(true).appendTo($slides);
            }
        }

        // $(document).on('click', '.sticky-add-cart', function () {
        //   $('.product-form__buttons button[name="add"]').click();
        // });
        
            $(document).on('click', '.sticky-scroll-to-product', function () {
                if ($(this).hasClass('disabled')) return;

                var mediaGallery = document.querySelector('media-gallery');

                if (mediaGallery) {
                    var offset = window.innerWidth < 768 ? (-40) : 500;

                    // Safari compatible position calculation
                    var rect = mediaGallery.getBoundingClientRect();
                    var galleryBottom = rect.top + window.pageYOffset + mediaGallery.offsetHeight - offset;

                    window.scrollTo({
                        top: galleryBottom,
                        behavior: 'smooth'
                    });

                } else {
                    var target =
                        document.querySelector('.product__title') ||
                        document.getElementById('main_product_redirect') ||
                        document.querySelector('.product__info-container');

                    if (target) {
                        target.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }
            });

            const chewDosageModal = document.getElementById("chewDosageInline");
            const popup = document.getElementById("dogPopup");
            const openBtn = document.getElementById("openDogGuide");
            const closeDogBtn = document.getElementById("closeDogGuide");

            // function closeChewDosageModal() {
            //     if (!chewDosageModal) return;
            //     chewDosageModal.style.display = "none";
            // }

        // function openChewDosageModal() {
        //         if (!chewDosageModal) return;
        //         chewDosageModal.style.display = "flex";
        //         setTimeout(function() {
        //             var searchEl = chewDosageModal.querySelector("[data-breed-search]");
        //             if (searchEl) searchEl.focus();
        //         }, 100);
        //     }

           if (chewDosageModal) {

                const closeChewBtn = document.getElementById("closeChewDosageGuide");
                const breedUi = chewDosageModal.querySelector("[data-chew-breed-ui]");
                const breedToggle = chewDosageModal.querySelector("[data-breed-toggle]");
                const breedToggleLabel = chewDosageModal.querySelector("[data-breed-toggle-label]");
                const breedDropdown = chewDosageModal.querySelector("[data-breed-dropdown]");
                const breedSearch = chewDosageModal.querySelector("[data-breed-search]");
                const breedList = chewDosageModal.querySelector("[data-breed-list]");
                const dosageResult = chewDosageModal.querySelector("[data-dosage-result]");
                const dosageFor = chewDosageModal.querySelector("[data-dosage-for]");
                const dosagePill = chewDosageModal.querySelector("[data-dosage-pill]");

                function dailyChewsForBedSize(bedSize) {
                    var u = String(bedSize || "").trim().toUpperCase();
                // Small dogs
                if (u === "XS" || u === "S" || u === "M") return 1;
                // Medium dogs
                if (u === "L" || u === "XL") return 2;
                // Large dogs
                return 3;
                }

                function daySupply(chews, bedSize) {
                    var daily = dailyChewsForBedSize(bedSize);
                    if (!daily) return 0;
                    return Math.max(1, Math.floor(Number(chews) / daily));
                }

                 /** customer pays */
                // function paidChewsInOffer(row) {
                //     var total = Number(row.getAttribute("data-chews-qty")) || 0;
                //     var bundleUnits = Number(row.getAttribute("data-qty")) || 0;
                //     var buy = Number(row.getAttribute("data-buy-qty"));
                //   if (!total || !bundleUnits || !Number.isFinite(buy) || buy < 1) return total;
                //     return Math.floor((total * buy) / bundleUnits);
                // }

                function totalChewsInOffer(row) {
                    return Number(row.getAttribute("data-chews-qty")) || 0;
                    }

                function setBreedDropdownOpen(isOpen) {
                    if (!breedDropdown || !breedToggle) return;
                    breedDropdown.classList.toggle("hide", !isOpen);
                    breedToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
                }

                function applyBreedSelection(breedName, bedSize) {
                    var firstOffer = document.querySelector(".offer-item[data-chews-qty]");
                    var baseChews = firstOffer
                        ? Number(firstOffer.getAttribute("data-chews-qty")) || 60
                        : 60;
                    var baseDays = daySupply(baseChews, bedSize);

                    if (breedToggleLabel) breedToggleLabel.textContent = breedName;
                    if (dosageFor) {
                        dosageFor.textContent =
                            "For your " +
                            breedName ;
                    }
                    if (dosagePill) {
                        dosagePill.textContent =
                            baseChews + " chews = " + baseDays + " Day Supply";
                    }
                   
                    if (dosageResult) dosageResult.classList.remove("hide");

                    document.querySelectorAll(".offer-item[data-chews-qty]").forEach(function (row) {
                               var chewsForSupply = totalChewsInOffer(row);
                        var days = daySupply(chewsForSupply, bedSize);
                        var label = days + "-Day Supply";
                        row.querySelectorAll("[data-offer-supply-tag]").forEach(function (tag) {
                            tag.textContent = label;
                            tag.hidden = false;
                             tag.classList.add('show-supply');
                        });
                    });
                }

                // openBtn.addEventListener("click", function (event) {
                //     event.preventDefault();
                //     openChewDosageModal();
                // });
                
               // closeBtn.addEventListener("click", function (event) {
                //     event.preventDefault();
                //     closeChewDosageModal();
                // });
                // if (closeChewBtn) {
                //     closeChewBtn.addEventListener("click", function () {
                //         closeChewDosageModal();
                //     });
                // }

                // chewDosageModal.addEventListener("click", function (event) {
                //     if (event.target === chewDosageModal) closeChewDosageModal();
                // });

                // document.addEventListener("keydown", function (event) {
                //     if (event.key === "Escape" && chewDosageModal.style.display === "flex") {
                //         closeChewDosageModal();
                //     }
                // });

               if (breedToggle && breedDropdown) {
    breedToggle.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = breedDropdown.classList.contains("hide");
        setBreedDropdownOpen(open);
        if (open && breedSearch) {
            breedSearch.value = "";
            breedList.querySelectorAll(".option-list").forEach(function (opt) {
                opt.style.display = "block";
            });
            breedList.classList.remove("hide");
            setTimeout(function () {
                breedSearch.focus();
            }, 50);
        }
    });
}

                document.addEventListener("click", function (event) {
                    if (!breedUi || !breedDropdown || breedDropdown.classList.contains("hide")) return;
                    if (!breedUi.contains(event.target)) setBreedDropdownOpen(false);
                });

          var highlightedIndex = -1;

function getVisibleOptions() {
    return Array.from(breedList.querySelectorAll(".option-list")).filter(function (opt) {
        return opt.style.display !== "none";
    });
}

function setHighlighted(index) {
    var opts = getVisibleOptions();
    opts.forEach(function (opt) { opt.classList.remove("highlighted"); });
    if (index < 0 || index >= opts.length) return;
    opts[index].classList.add("highlighted");
    opts[index].scrollIntoView({ block: "nearest" });
}

function selectOption(opt) {
    var bed = opt.getAttribute("data-value") || "";
    var name = opt.textContent.trim();
    breedSearch.value = "";
    setBreedDropdownOpen(false);
    highlightedIndex = -1;
    applyBreedSelection(name, bed);
}

if (breedSearch && breedList) {
    breedSearch.addEventListener("input", function () {
        var q = breedSearch.value.toLowerCase().trim();
        highlightedIndex = -1;
        if (q) {
            breedList.classList.remove("hide");
        } else {
            breedList.classList.add("hide");
        }
        breedList.querySelectorAll(".option-list").forEach(function (opt) {
            opt.style.display =
                !q || opt.textContent.toLowerCase().indexOf(q) !== -1
                    ? "block"
                    : "none";
        });
    });

    breedSearch.addEventListener("keydown", function (e) {
        var opts = getVisibleOptions();
        if (!opts.length) return;

        if (e.key === "ArrowDown") {
            e.preventDefault();
            breedList.classList.remove("hide");
            highlightedIndex = Math.min(highlightedIndex + 1, opts.length - 1);
            setHighlighted(highlightedIndex);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            highlightedIndex = Math.max(highlightedIndex - 1, 0);
            setHighlighted(highlightedIndex);
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (highlightedIndex >= 0 && opts[highlightedIndex]) {
                selectOption(opts[highlightedIndex]);
            }
        } else if (e.key === "Escape") {
            breedList.classList.add("hide");
            highlightedIndex = -1;
        }
    });
}

if (breedList) {
    breedList.addEventListener("click", function (event) {
        var opt = event.target.closest(".option-list");
        if (!opt || !breedList.contains(opt)) return;
        event.preventDefault();
        selectOption(opt);
    });
}
            } else if (popup && openBtn && closeDogBtn) {
                // openBtn.addEventListener("click", function (event) {
                //     event.preventDefault();
                //     popup.style.display = "flex";
                // });

                closeDogBtn.addEventListener("click", function () {
                    popup.style.display = "none";
                });

                popup.addEventListener("click", function (event) {
                    if (event.target === popup) popup.style.display = "none";
                });
            }

        $('.dynamic-atc-title').text($('.offer-item:has(input:checked)').find('.offer-title:first').text());
        $('.dynamic-atc-price').text(' - '+$('.offer-item:has(input:checked)').find('.offer-buy-price:first .money').text());
       $('#sticky-product-bar .sticky-add-cart span:first').text($('.product-form__buttons button[name="add"]').text().toUpperCase());

        $(document).on('click', '.offer-item', function () {
            var $item = $(this);
            var qty = $item.data('qty');
            var $product = $item.closest('.mff_product.product');
            $product.find('.offer-item').removeClass('selected');
            $item.addClass('selected');
            $item.find('input[type="radio"]').prop('checked', true);
            $product.find('.offer_item_quantity_input').val(qty);
            $('.dynamic-atc-title').text($item.find('.offer-title:first').text());
            $('.dynamic-atc-price').text(' - '+$item.find('.offer-buy-price:first .money').text());

            var mainBtn = $('.product-form__buttons button[name="add"]');
            var stickyBtn = $('#sticky-product-bar .sticky-add-cart span:first');
            // stickyBtn.text(mainBtn.text());
            if (mainBtn.prop('disabled')) {
                stickyBtn.prop('disabled', true);
                stickyBtn.addClass('disabled');
            } else {
                stickyBtn.prop('disabled', false);
                stickyBtn.removeClass('disabled');
            }

            var $stickyBarMAIN = $('#sticky-product-bar');

            var $stickyBar = $('#sticky-product-bar .sticky-product-price');
            if (!$stickyBar.length) return;
            var comparePrice = $item.find('.offer-compare-price:first').text().trim();
            var buyPrice = $item.find('.offer-buy-price:first').text().trim();
            var savePrice = $item.find('.offer-save-price:first').text().trim();
            $stickyBarMAIN.find('.dropdown-selected__title small').text(savePrice.replace(/save/i, ''));

            // compare price
            if (comparePrice) {
                $stickyBar.find('.compare-price').removeClass('hidden');
                $stickyBar.find('.compare-price').text(comparePrice);
            } else {
                $stickyBar.find('.compare-price').addClass('hidden');
            }

            // main price
            if (buyPrice) {
                $stickyBar.find('.price').removeClass('hidden');
                $stickyBar.find('.price').text(buyPrice);
            } else {
                $stickyBar.find('.price').addClass('hidden');
            }

            // save badge
            if (savePrice) {
                $stickyBar.find('.save-badge').removeClass('hidden');
                $stickyBar.find('.save-badge').text(savePrice.replace(/save/i, ''));
            } else {
                $stickyBar.find('.save-badge').addClass('hidden');
            }
        });

        $('.offer-item').eq(1).trigger('click');

    });